import { useEffect, useState } from "react";
import Container from "../components/basicComponents/container";
import Grid from "../components/grid";
import {
  getFaqs,
  addFaq,
  removeFaq,
  editFaq,
} from "../state-management/actions/faq-actions";
import { useSelector, useDispatch } from "react-redux";
import { FaqProps } from "../types/public";
import {
  setAlert,
  setAlertSeverity,
  setAlertContext,
} from "../state-management/actions/alerts-actions";
import * as Icons from "../assets/SVGs/index";
import Button from "../components/basicComponents/button";
import TextInput from "../components/basicComponents/text-input";
import TextArea from "../components/basicComponents/text-area";
import { selectGlobalState } from "../state-management/selectors";
import ToggleSwitch from "../components/basicComponents/switch-box";
import { setRowStatus } from "../state-management/actions/global-state-actions";
import activeitesQuantity from "../utils/activitiesQuantity";

const initialData: FaqProps = {
  email: "",
  question: "",
  answer: "",
  release_status: false,
  create_by: "",
};

const Faq = () => {
  const dispatch = useDispatch();
  const [faqsData, setFaqsData] = useState<any>([]);
  const { currentUserData, rowStatus, usersData } =
    useSelector(selectGlobalState);
  const [newQuestion, setNewQestion] = useState<FaqProps>(initialData);
  activeitesQuantity();

  useEffect(() => {
    const fatchData = async () => {
      try {
        const response = await getFaqs()(dispatch);
        if (response.data) {
          setFaqsData(response.data);
          setNewQestion(initialData);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fatchData();
  }, [dispatch]);

  const handleSubmit = async () => {
    try {
      const data = {
        ...newQuestion,
        created_by: currentUserData._id,
      };
      const response = await addFaq(data)(dispatch);
      if (response.data) {
        setFaqsData([...faqsData, { ...data, _id: response.data.NewItem._id }]);
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("ثبت سوال با موفقیت صورت پذیرفت"));
        setNewQestion(initialData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = async () => {
    try {
      const { _id, ...cleanData } = newQuestion;
      const response = await editFaq(_id, cleanData)(dispatch);
      if (response.data) {
        setFaqsData(
          faqsData.map((faq: any) =>
            faq._id === _id ? { ...faq, ...cleanData } : faq
          )
        );
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext(" سئوال مربوطه ویرایش شد"));
      }
      dispatch(setRowStatus("clear id", false));
      setNewQestion(initialData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSetEditData = async (clear: boolean, id: any) => {
    const setData = faqsData.find((item: any) => item._id === id);
    if (!clear && setData) {
      setNewQestion(setData);
    }
    if (clear) {
      setNewQestion(initialData);
    }
  };

  const handleDelete = async (id: string) => {
    try {
      console.log(id, "ff");
      const response = await removeFaq(id)(dispatch);
      if (response.status === 200) {
        setFaqsData(faqsData.filter((faq: any) => faq._id !== id));
        dispatch(setAlert(true));
        dispatch(setAlertSeverity("success"));
        dispatch(setAlertContext("حذف سوال با موفقیت صورت پذیرفت"));
      }
    } catch (error) {
      console.log(error);
    }
    console.log("hh");
  };

  const columns: any = [
    {
      headerName: "سوال",
      field: "question",
    },
    {
      headerName: "پاسخ سوال",
      field: "answer",
    },
    {
      headerName: "ایجاد کننده",
      valueGetter: (params: any) => {
        const author = usersData.find(
          (user: any) => user._id === params.data.created_by
        );
        return author ? `${author.firstname} ${author.lastname}` : "";
      },
      field: "created_by",
    },
    {
      headerName: "ایمیل درخواست کننده",
      field: "email",
    },
    {
      headerName: "وضعیت نمایش",
      field: "release_status",
    },
  ];
  return (
    <div className="flex flex-col items-center w-full">
      <Container header="سوالات متداول">
        <div
          className="flex justify-around w-full"
          style={{ marginTop: "30px", gap: "10px" }}
        >
          <TextInput
            name="question"
            value={newQuestion.question}
            placeholder="سوال را وارد کنید"
            onChange={(e) => {
              setNewQestion((prev) => ({
                ...prev,
                question: e.target.value,
              }));
            }}
            label={`سوال `}
            RightIcon={<Icons.FaqIcon className="w-5 h-5" />}
          />
        </div>
        <div className=" w-full">
          <TextArea
            name="answer"
            value={newQuestion.answer}
            placeholder="پاسخ سوال را اینجا وارد کنید"
            onChange={(e) => {
              setNewQestion((prev) => ({
                ...prev,
                answer: e.target.value,
              }));
            }}
            rows={5}
          />
        </div>
        <div>
          <ToggleSwitch
            label="وضعیت انتشار"
            checked={newQuestion.release_status ?? false}
            onChange={() => {
              setNewQestion((prev) => ({
                ...prev,
                release_status: !prev.release_status,
              }));
            }}
          />
        </div>
        <div className="mb-5">
          <Button
            type="button"
            variant={!rowStatus?.status ? "success" : "edit"}
            title={!rowStatus?.status ? "ثبت" : "ویرایش"}
            onClick={!rowStatus?.status ? handleSubmit : handleEdit}
            bgColor="#9EE1D1"
            borderColor="#00B087"
            color="#00B087"
          />
        </div>
      </Container>
      <Container header="لیست سوالات">
        <div className="w-full">
          <Grid
            height={700}
            columns={columns}
            userData={faqsData}
            pageSize={10}
            pagination={true}
            editBtn={true}
            deleteBtn={true}
            publishBtn={false}
            editable={false}
            btnHeader="عملیات"
            handleSetData={handleSetEditData}
            handleDelete={handleDelete}
          />
        </div>
      </Container>
    </div>
  );
};

export default Faq;
